import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class MockHeaderInteractionService {
  protected readonly router: Router = inject(Router);

  navigate(_routes: string[]) {}

  logout() {}
}
